import { render, staticRenderFns } from "./TaskVehicle.vue?vue&type=template&id=f8650510"
import script from "./TaskVehicle.vue?vue&type=script&lang=js"
export * from "./TaskVehicle.vue?vue&type=script&lang=js"
import style0 from "./TaskVehicle.vue?vue&type=style&index=0&id=f8650510&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports